export default __webpack_public_path__ + "static/ti-hobbiton-new-zealand-e0bfd14f9a16c05454bf1815dfe9d097.jpg";